import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PortfolioBalancePage() {
  const [quickWins, setQuickWins] = useState('');
  const [bigBets, setBigBets] = useState('');
  const [sustaining, setSustaining] = useState('');
  const [learning, setLearning] = useState('');

  const quickWinsCount = quickWins.split('\n').filter(Boolean).length;
  const bigBetsCount = bigBets.split('\n').filter(Boolean).length;
  const totalItems = quickWinsCount + bigBetsCount + sustaining.split('\n').filter(Boolean).length;
  const bigBetsPercent = totalItems > 0 ? (bigBetsCount / totalItems) * 100 : 0;

  return (
    <TaskPage
      phase="arrange"
      title="Portfolio Balance"
      pageNumber={4}
      instruction="Avoid all eggs in one basket. Place each shortlisted item in: Quick Wins • Big Bets • Sustaining • Learning Experiments. Aim for at least one in each of the first three."
      whyItMatters="One page = one concept; clear layout and whitespace keep attention on the balancing act, not on deciphering the page."
      coachRail={{
        timing: "10 minutes",
        tips: "Capacity nudge: if &gt;50% are Big Bets, choose one to keep and slice or defer the rest.",
        debrief: "Is our portfolio balanced? Do we have variety?"
      }}
    >
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
            <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">
              Quick Wins ({quickWinsCount})
            </h3>
            <TextArea
              label="Items that deliver fast, high-confidence value"
              value={quickWins}
              onChange={(e) => setQuickWins(e.target.value)}
              placeholder="Fast wins that build momentum..."
              rows={6}
            />
          </div>

          <div className="bg-[var(--coral-dim)] border border-[var(--coral)] p-6">
            <h3 className="text-lg font-semibold text-[var(--coral)] mb-4">
                Big Bets ({bigBetsCount})
                {bigBetsPercent > 50 && (
                <span className="ml-2 text-xs text-[var(--coral)]">⚠️ &gt;50% - consider slicing</span>
                )}
            </h3>
            <TextArea
              label="Items with high impact potential but higher risk"
              value={bigBets}
              onChange={(e) => setBigBets(e.target.value)}
              placeholder="Bold moves with potential for transformation..."
              rows={6}
            />
          </div>

          <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
            <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Sustaining</h3>
            <TextArea
              label="Items that maintain current capabilities"
              value={sustaining}
              onChange={(e) => setSustaining(e.target.value)}
              placeholder="Work that keeps the lights on..."
              rows={6}
            />
          </div>

          <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
            <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Learning Experiments</h3>
            <TextArea
              label="Items to test assumptions and learn"
              value={learning}
              onChange={(e) => setLearning(e.target.value)}
              placeholder="Experiments to validate hypotheses..."
              rows={6}
            />
          </div>
        </div>

        {bigBetsPercent > 50 && (
          <Callout type="risk" phase="arrange">
            <p className="text-sm">⚠️ More than 50% are Big Bets. Choose one to keep and slice or defer the rest to balance capacity.</p>
          </Callout>
        )}

        <Callout type="tip" phase="arrange">
          <p className="text-sm">Aim for at least one item in Quick Wins, Big Bets, and Sustaining. Balance prevents over-commitment to risky bets.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}

